__turbopack_context__.v({
  "badge": "ProfileHero-module-scss-module__eVG42q__badge",
  "crumb": "ProfileHero-module-scss-module__eVG42q__crumb",
  "desc": "ProfileHero-module-scss-module__eVG42q__desc",
  "heading": "ProfileHero-module-scss-module__eVG42q__heading",
  "hero": "ProfileHero-module-scss-module__eVG42q__hero",
  "media": "ProfileHero-module-scss-module__eVG42q__media",
  "meta": "ProfileHero-module-scss-module__eVG42q__meta",
  "search": "ProfileHero-module-scss-module__eVG42q__search",
  "searchRow": "ProfileHero-module-scss-module__eVG42q__searchRow",
  "stats": "ProfileHero-module-scss-module__eVG42q__stats",
  "title": "ProfileHero-module-scss-module__eVG42q__title",
  "top": "ProfileHero-module-scss-module__eVG42q__top",
  "wrap": "ProfileHero-module-scss-module__eVG42q__wrap",
});
